import { Phone, Menu, X, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { useState } from "react";
import { companyInfo } from "../data/mock";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="container mx-auto px-4">
        {/* Top bar with emergency contact */}
        <div className="border-b border-slate-100 py-2">
          <div className="flex justify-between items-center text-sm">
            <span className="text-slate-600">24/7 Emergency Service Available</span>
            <div className="flex items-center gap-4">
              <a 
                href={`https://wa.me/${companyInfo.whatsappNumber}?text=Hi, I need help with car transportation`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-green-600 font-semibold hover:text-green-700 transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
                <span className="hidden md:inline">WhatsApp</span>
              </a>
              <a 
                href={`tel:${companyInfo.emergencyPhone}`}
                className="flex items-center gap-2 text-red-600 font-semibold hover:text-red-700 transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden sm:inline">Call: </span>
                {companyInfo.emergencyPhone}
              </a>
            </div>
          </div>
        </div>

        {/* Main navigation */}
        <div className="py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">O</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-900">{companyInfo.name}</h1>
              <p className="text-xs text-slate-500">Professional Car Transport Services</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('coverage')}
              className="text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Coverage
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Testimonials
            </button>
            <a 
              href="/blog"
              className="text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Blog
            </a>
            <Button 
              onClick={() => scrollToSection('quote')}
              className="bg-slate-900 hover:bg-slate-800 text-white"
            >
              Get a Quote
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-slate-200 space-y-3">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left py-2 text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="block w-full text-left py-2 text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('coverage')}
              className="block w-full text-left py-2 text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Coverage
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left py-2 text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Testimonials
            </button>
            <a 
              href="/blog"
              className="block w-full text-left py-2 text-slate-700 hover:text-slate-900 font-medium transition-colors"
            >
              Blog
            </a>
            <Button 
              onClick={() => scrollToSection('quote')}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white"
            >
              Get a Quote
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};
